import InventoryUnitAPI from '@/API/inventory/InventoryUnitAPI'
import InventorySupplierAPI from '@/API/inventory/InventorySupplierAPI'
import InventoryItemAPI from '@/API/inventory/InventoryItemAPI'

export default {
  namespaced: true,
  state: {
    unitsFetched: false,
    supplierFetched: false,
    dependenciesFetched: false,
    units: [],
    suppliers: [],
    sku: '',
  },
  getters: {
    suppliers: (state: any) => state.suppliers,
    units: (state: any) => state.units,
    sku: (state: any) => state.sku,
  },
  mutations: {
    SET_UNITS(state: any, units: any) {
      state.units = units
      state.unitsFetched = true
    },
    UPDATE_UNITS(state: any, unit: any) {
      state.units = [...state.units, unit]
    },
    UPDATE_SUPPLIERS(state: any, supplier: any) {
      state.suppliers = [...state.suppliers, supplier]
    },
    SET_SUPPLIERS(state: any, suppliers: any) {
      state.suppliers = suppliers
      state.supplierFetched = true
    },
    SET_DEPENDENCIES_FETCHED(state: any) {
      state.dependenciesFetched = true
    },
    SET_SKU(state: any, sku: any) {
      state.sku = sku
    },
    DELETE_UNIT(state: any, unit_id: any) {
      state.units = state.units.filter((u: any) => u.id !== unit_id)
    },
  },
  actions: {
    async FETCH_UNITS(context: any) {
      if (context.state.unitsFetched) return
      // eslint-disable-next-line consistent-return,no-return-await
      await InventoryUnitAPI.list().then(response => {
        context.commit('SET_UNITS', response)
      })
    },
    async FETCH_SUPPLIERS(context: any) {
      if (context.state.supplierFetched) return
      // eslint-disable-next-line consistent-return,no-return-await
      await InventorySupplierAPI.list().then(response => {
        context.commit('SET_SUPPLIERS', response)
      })
    },
    async FETCH_ITEM_DEPENDENCIES(context: any) {
      if (context.state.dependenciesFetched) return
      // eslint-disable-next-line consistent-return,no-return-await
      await InventoryItemAPI.getDependencies().then(response => {
        context.commit('SET_SUPPLIERS', response.suppliers)
        context.commit('SET_UNITS', response.units)
        context.commit('SET_DEPENDENCIES_FETCHED')
        context.commit('SET_SKU', response.sku)
      })
    },
  },
}
